import styled from 'styled-components';

export const AttendeePersonalInfoItem = styled.div`
  padding: 10px 0;
`;

export const AttendeeInfoTitle = styled.div`
  font-weight: bold;
  font-size: 13px;
  line-height: 13px;
  color: #484848;
`;

export const AttendeeInfoAnswer = styled.div`
  font-size: 14px;
  line-height: 18px;
  color: #484848;
  margin: 8px 0;
`;
